module.exports = __webpack_public_path__ + "img/support.084f907d.svg";